import {useCurrentOrganization, useCurrentWorkspaceParent} from "@tinct/core-workspace";
import {useManageSubscription} from "../hooks/use-manage-subscription";
import {CardPlan} from "@tinct/web-components";
import {useOpenPaywall} from "../modal/paywall-pro-required-modal/paywall-pro-required-modal";

export const TinctPlanCard = () => {

  const { openPaywall } = useOpenPaywall();

  const currentOrganization = useCurrentOrganization();
  const isSubscribed = currentOrganization.subscription !== null;

  // An agency child is served its parent's subscription through the API
  // fallback — it is not theirs to manage, so hide the button.
  const isAgencyChild = useCurrentWorkspaceParent() !== null;

  const creditsQuota = currentOrganization.activeQuotas?.find(q => q.featureKey === 'lp_generation_credit');
  const lpQuota = currentOrganization.activeQuotas?.find(q => q.featureKey === 'lp_publication');
  const { handleManageSubscription, isPending } = useManageSubscription();

  return <CardPlan
    className="group-data-[collapsible=icon]:hidden"
    onAction={() => {
      if(!isSubscribed) {
        openPaywall()
      }else {
        handleManageSubscription()
      }
    }}
    buttonProps={{
      disabled: isPending
    }}
    hideAction={isAgencyChild && isSubscribed}
    variant={isSubscribed ? 'paid' : 'free'}
    usageStats={[
      {
        label: 'credits left',
        value: creditsQuota?.remainingQuota ?? 0,
        percent:  creditsQuota?.quotaLimit ? Math.floor(((creditsQuota.quotaLimit - (creditsQuota.remainingQuota ?? 0)) / creditsQuota.quotaLimit) * 100) : 0,
      },
      {
        label: 'page variants left',
        value: lpQuota?.remainingQuota ?? 0,
        percent: lpQuota?.quotaLimit ? Math.floor(((lpQuota.quotaLimit - (lpQuota.remainingQuota ?? 0)) / lpQuota.quotaLimit) * 100) : 0,
      },
    ]}
  />
}
